import { dispatchAction } from '@ardoq/rxbeach';
import * as metaInfoActions from './metaInfoActions';

export const getMetaInfoCommands = (namespace: string) => ({
  setName: (name: string) =>
    dispatchAction(metaInfoActions.setTraversalName({ name }), namespace),

  setDescription: (description: string) => {
    dispatchAction(
      metaInfoActions.setTraversalDescription({ description }),
      namespace
    );
  },

  setFolderId: (folderId: string | null) =>
    dispatchAction(metaInfoActions.setFolderId(folderId), namespace),

  setInitialMetaInfo: (payload: metaInfoActions.SetInitialMetaInfoPayload) =>
    dispatchAction(metaInfoActions.setInitialMetaInfo(payload), namespace),
});

export type MetaInfoCommands = ReturnType<typeof getMetaInfoCommands>;
